"use client";

import { useRef } from "react";

interface ScrollButtonProps {
  targetId: string;
  children: React.ReactNode;
  className?: string;
}

export default function ScrollButton({
  targetId,
  children,
  className = "",
}: ScrollButtonProps) {
  const buttonRef = useRef<HTMLButtonElement>(null);

  const handleClick = () => {
    const section = document.getElementById(targetId);

    if (section) {
      section.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <button
      ref={buttonRef}
      onClick={handleClick}
      className={className}
    >
      {children}
    </button>
  );
}